import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

const ModernHeaderV2 = ({ setSidebarOpen, user, title }) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const [currentDateTime, setCurrentDateTime] = useState('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      
      hours = hours % 12;
      hours = hours ? hours : 12;
      const formattedHours = String(hours).padStart(2, '0');
      
      setCurrentDateTime(`${day}-${month}-${year}  ${formattedHours}:${minutes}:${seconds} ${ampm}`);
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 w-full bg-white border-b border-gray-200">
      <div className="w-full px-4 sm:px-6">
        <div className="flex items-center justify-between h-[60px]">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
            >
              <Icons.Menu className="w-5 h-5" />
            </button>

            <Link to="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
              <div className="w-8 h-8 bg-gradient-to-br from-indigo-600 to-indigo-700 rounded-lg flex items-center justify-center shadow-sm">
                <Icons.Zap className="w-4 h-4 text-white" />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-base font-semibold text-gray-900">Way2Connect</h1>
              </div>
            </Link>

            {title && (
              <div className="hidden lg:flex items-center pl-4 ml-4 border-l border-gray-200">
                <h2 className="text-sm font-medium text-gray-700">{title}</h2>
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-200">
              <Icons.Clock className="w-3.5 h-3.5 text-gray-500" />
              <span className="text-xs font-mono text-gray-700">
                {currentDateTime}
              </span>
            </div>

            <div className={`hidden sm:flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold ${
              isProduction 
                ? 'bg-green-50 text-green-700 border border-green-200' 
                : 'bg-amber-50 text-amber-700 border border-amber-200'
            }`}>
              <div className={`w-1.5 h-1.5 rounded-full ${
                isProduction ? 'bg-green-500' : 'bg-amber-500'
              } animate-pulse`} />
              {isProduction ? 'LIVE' : 'TEST'}
            </div>

            <button className="relative p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors">
              <Icons.Bell className="w-5 h-5" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
            </button>

            <div className="flex items-center gap-2 pl-2 ml-2 border-l border-gray-200">
              <div className="hidden sm:block text-right">
                <p className="text-sm font-medium text-gray-900">
                  {user?.full_name || user?.username}
                </p>
                <p className="text-xs text-gray-400">@{user?.username} <span className="text-gray-500 capitalize">{user?.role?.replace('_', ' ')}</span></p>
              </div>
              <div className="relative">
                <div className="w-9 h-9 bg-gradient-to-br from-indigo-600 to-indigo-700 rounded-full flex items-center justify-center text-white font-semibold text-sm shadow-sm">
                  {user?.full_name?.[0] || user?.username?.[0]?.toUpperCase() || 'U'}
                </div>
                <div className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ModernHeaderV2;
